import React, { useEffect } from "react";
import ModalBox from "../../../Components/modals/ModalBox";
import CreateForm from "./../CreateModalContent/CreateForm";
import ContactInformation from "../CreateModalContent/ContactInformation";
import HomeInformation from "../CreateModalContent/HomeInformation";
import PersonalInformation from "../CreateModalContent/PersonalInformation";
import MedicalInformation from "../CreateModalContent/MedicalInformation";
import AdditionalOptions from "../CreateModalContent/AdditionalOptions";

function UpdateInfoModal(props) {
  const { showModal, closeModal, editKey, type } = props;
  // console.log(props);
  useEffect(() => {
    // fetchData();
  }, [showModal]);

  return (
    <ModalBox
      isShow={showModal}
      handleClose={closeModal}
      modalSize="lg"
      bodyClassName="accrdn-modal-body"
      hasData={true}
    >
      {(() => {
        switch (type) {
          case "contact":
            return <ContactInformation {...props}/>

          case "home":
            return <HomeInformation {...props}/>

          case "personal":
            return <PersonalInformation {...props}/>

          case "medical":
            return <MedicalInformation {...props}/>

          case "additional":
            return <AdditionalOptions {...props} title="Account Information" />
          
          default:
            return <CreateForm {...props}/>
        }
      })()}
    </ModalBox>
  );
}

export default UpdateInfoModal;
